export function countUnsubmittedReviews(progress: readonly { submitted: number; total: number }[] | undefined): number {
    return (progress ?? []).reduce((count, { submitted, total }) => count + Math.max(total - submitted, 0), 0);
}
